import { Controller } from "stimulus";

const DESKTOP_QUERY = "(min-width: 992px)";

export default class extends Controller {
  connect() {
    this.popover = null;
    this.popoverBar = null;
    this.desktopQuery = window.matchMedia(DESKTOP_QUERY);
    this.boundDocumentClick = this.handleDocumentClick.bind(this);
    this.boundKeydown = this.handleKeydown.bind(this);
    this.boundSyncLabels = this.syncMoreLabels.bind(this);
    document.addEventListener("click", this.boundDocumentClick);
    document.addEventListener("keydown", this.boundKeydown);
    this.desktopQuery.addEventListener("change", this.boundSyncLabels);
    this.syncMoreLabels();
  }

  disconnect() {
    document.removeEventListener("click", this.boundDocumentClick);
    document.removeEventListener("keydown", this.boundKeydown);
    this.desktopQuery.removeEventListener("change", this.boundSyncLabels);
  }

  get dense() {
    return this.element.classList.contains("dc-lane-dense") && this.desktopQuery.matches;
  }

  moreLabel(button, expanded) {
    const labels = button.dataset;
    if (this.dense) return expanded ? labels.lessShortLabel : labels.moreShortLabel;
    return expanded ? labels.lessLabel : labels.moreLabel;
  }

  syncMoreLabels() {
    this.element.querySelectorAll(".dc-lane-more").forEach((button) => {
      button.textContent = this.moreLabel(button, button.closest(".dc-lane-day").classList.contains("expanded"));
    });
  }

  toggleBlocks(event) {
    const button = event.currentTarget;
    const expanded = button.closest(".dc-lane-day").classList.toggle("expanded");
    button.textContent = this.moreLabel(button, expanded);
    if (this.popoverBar && !this.popoverBar.offsetParent) this.closeBlockPopover(false);
  }

  toggleLaneAll(event) {
    const button = event.currentTarget;
    const expanded = this.element.classList.toggle("dc-lane-expanded");
    button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
    if (this.popoverBar && !this.popoverBar.offsetParent) this.closeBlockPopover(false);
  }

  toggleBlockPopover(event) {
    const bar = event.currentTarget;
    if (this.popoverBar === bar) {
      this.closeBlockPopover();
      return;
    }
    const popover = this.element.querySelector(`.dc-m-popover[data-block-id="${bar.dataset.blockId}"]`);
    if (!popover) return;
    this.closeBlockPopover(false);
    this.popoverBar = bar;
    this.popover = popover;
    bar.classList.add("dc-m-block-selected");
    bar.setAttribute("aria-expanded", "true");
    popover.classList.add("open");
    this.positionPopover(popover, bar, event.detail > 0 ? event.clientX : null);
    const close = popover.querySelector(".dc-m-pop-close");
    if (close) close.focus({ preventScroll: true });
  }

  positionPopover(popover, bar, pointerX) {
    const laneRect = this.element.getBoundingClientRect();
    const barRect = bar.getBoundingClientRect();
    const width = popover.offsetWidth;
    const height = popover.offsetHeight;
    const originLeft = laneRect.left + this.element.clientLeft;
    const originTop = laneRect.top + this.element.clientTop;
    let top = barRect.bottom - originTop + 4;
    if (barRect.bottom + height + 8 > window.innerHeight && barRect.top - height - 8 > 0) {
      top = barRect.top - originTop - height - 4;
    }
    const anchor = pointerX === null ? barRect.left : Math.max(barRect.left, pointerX - 16);
    const left = Math.min(Math.max(0, anchor - originLeft), Math.max(0, this.element.clientWidth - width));
    popover.style.top = `${top}px`;
    popover.style.left = `${left}px`;
  }

  closeBlockPopover(restoreFocus = true) {
    if (!this.popover) return;
    const bar = this.popoverBar;
    this.popover.classList.remove("open");
    bar.classList.remove("dc-m-block-selected");
    bar.setAttribute("aria-expanded", "false");
    this.popover = null;
    this.popoverBar = null;
    if (restoreFocus !== false && bar.isConnected) bar.focus({ preventScroll: true });
  }

  handleDocumentClick(event) {
    if (!this.popover) return;
    if (this.element.contains(event.target) && event.target.closest(".dc-m-popover, .dc-lane-bar")) return;
    this.closeBlockPopover(false);
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.popover) this.closeBlockPopover();
  }
}
